/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry, Rachel Ralston

Description:
*/
import React, { useContext } from 'react';
import Block from 'wfui-digital-core/es/Block';
import { getClasses } from 'wfui-digital-core/es/lib';
import BusinessEvent from '../../../../business-event/BusinessEvent';
import NavigationContext from './NavigationContext';
import NavigationMenuContainer from '../nav-menu/NavigationMenuContainer';
import NavigationBarButton from './NavigationBarButton';
import styles from './NavigationBarItem.less'; //  Summary of behaviors
//
// - Pin the navigation menu when the navigation bar item is clicked.
// - Clicking a pinned navigation menu unpins and closes it. The menu should not open again until
//   the mouse moves outside the bounds of the navigation bar item.
// - Click outside a pinned navigation menu unpins and closes it.
// - Block hover behavior if a non-"navMenu" child window is open or another navigation menu is pinned.
// - Keep an un-pinned navigation menu open while the cursor is over the navigation bar item or the modal content.

var NavigationBarItem = function NavigationBarItem(_ref, ref) {
  var showMenu = _ref.showMenu,
      bevName = _ref.bevName,
      item = _ref.item,
      highlighted = _ref.highlighted,
      navigationBarRef = _ref.navigationBarRef;

  var _useContext = useContext(NavigationContext),
      setMenuRef = _useContext.setMenuRef;

  var classes = ['navigationBarItem', highlighted ? 'highlighted' : ''];
  var classNames = getClasses({
    styles: styles,
    classes: classes
  });
  var style = !showMenu || showMenu && !item.fitPage ? {
    position: 'relative'
  } : {};
  return /*#__PURE__*/React.createElement(Block, {
    el: "li",
    layout: true,
    horizontal: true,
    centered: true,
    flex: true,
    basisZero: true,
    className: classNames,
    style: style
  }, bevName ? /*#__PURE__*/React.createElement(BusinessEvent, {
    eventId: bevName
  }, /*#__PURE__*/React.createElement(NavigationBarButton, {
    item: item,
    ref: ref,
    highlighted: highlighted
  })) : /*#__PURE__*/React.createElement(NavigationBarButton, {
    item: item,
    ref: ref,
    highlighted: highlighted
  }), showMenu && /*#__PURE__*/React.createElement(NavigationMenuContainer, {
    item: item,
    ref: setMenuRef,
    navigationBarRef: navigationBarRef
  }));
};

export default /*#__PURE__*/React.forwardRef(NavigationBarItem);